import * as React from "react";

export default () => {
  return <div>Objekt som behörigheten gäller för</div>;
};
